import { SocialPlatform } from '@app/modules/social-export/domain/platforms';
import { useStationPlatformConnections } from './useStationPlatformConnections';

/**
 * Returns whether the station has at least one connection for the given platform.
 */
export function useSocialExportConnectedForStation(stationId: string, platform: SocialPlatform) {
  const { connections, areConnectionsResolved } = useStationPlatformConnections(
    stationId,
    platform,
  );

  return areConnectionsResolved && connections.length > 0;
}
